let isSmoothScrollSupported = 'scrollBehavior' in document.querySelector('.Page').style;
if(!isSmoothScrollSupported) {
  import ('https://cdn.jsdelivr.net/gh/cferdinandi/smooth-scroll@15.0.0/dist/smooth-scroll.polyfills.min.js')
    .then((module) => {
      let scroll = new SmoothScroll('a[href*="#"]');
    });
}
